/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

export const INITIAL_STATE = {
	isAuthenticated: false,
	email: '',
	name: '',
	avatar: null,
	shouldUpdateStatistics: true,
	statistics: undefined
}

const userReducer = {
	updateState: (state, action) => ({ ...state, ...action.payload })
}

const userSlice = createSlice({
	name: 'user',
	initialState: INITIAL_STATE,
	reducers: userReducer
})

export default userSlice
